<template lang="pug">
  SspLayout(area="tnt")
    SspSaveForm(@onSubmit="save" :saving="saving" :saveDisabled="!isValid")
      .form-horizontal
        .form-group
          label.col-sm-4.control-label Name
          .col-sm-8
            input.index-input.form-control(placeholder="Enter name" v-model="packageType.name")

        .form-group
          label.col-sm-4.control-label Description
          .col-sm-8
            input.description-input.form-control(placeholder="Enter description"  v-model="packageType.description")

        .form-group
          label.col-sm-4.control-label Type
          .col-sm-3
            select.form-control.type-select(v-model="packageType.type")
              option(v-for="t in types") {{ t }}
          label.col-sm-2.control-label Material
          .col-sm-3
            select.form-control.material-select(v-model="packageType.material")
              option(v-for="material in materials") {{material}}

        .form-group
          label.col-sm-4.control-label Inner dimensions [m]
          .col-sm-8.no-side-padding
            .col-sm-4
              input.inner-H-input.form-control(type="number" step="any" placeholder="Height" v-model="packageType.internalHeight")
            .col-sm-4
              input.inner-W-input.form-control(type="number" step="any" placeholder="Width" v-model="packageType.internalWidth")
            .col-sm-4
              input.inner-L-input.form-control(type="number" step="any" placeholder="Length" v-model="packageType.internalLength")

        .form-group
          label.col-sm-4.control-label Outer dimensions [m]
          .col-sm-8.no-side-padding
            .col-sm-4
              input.outer-H-input.form-control(type="number" step="any" placeholder="Height" v-model="packageType.externalHeight")
            .col-sm-4
              input.outer-W-input.form-control(type="number" step="any" placeholder="Width" v-model="packageType.externalWidth")
            .col-sm-4
              input.outer-L-input.form-control(type="number" step="any" placeholder="Length" v-model="packageType.externalLength")

        .form-group
          label.col-sm-4.control-label Dry weight [kg]
          .col-sm-3
            input.dry-weight-input.form-control(type="number" step="any" placeholder="Enter dry weight" v-model="packageType.dryWeight")
          label.col-sm-2.control-label Max gross weight [kg]
          .col-sm-3
            input.max-gross-weight-input.form-control(type="number" step="any" placeholder="Enter max gross weight" v-model="packageType.maxGrossWeight")

        .form-group
          label.col-sm-4.control-label Code representation
          .col-sm-3
            select.form-control.type-select(v-model="packageType.codeRepresentation")
              option(v-for="t in codeRepresentations") {{ t }}
</template>

<script>
import miniToastr from 'mini-toastr'
import Masterdata from '@/service/apis/Masterdata'

export default {
  data: () => ({
    saving: false,
    packageType: {
      name: '',
      type: '',
      material: '',
      codeRepresentation: 'DEFAULT'
    },
    materials: ['', 'PAPER', 'CARDBOARD', 'METAL', 'PLASTIC', 'GLASS', 'WOOD', 'OTHER'],
    types: ['', 'CONTAINER', 'PALLET', 'BOX', 'BARREL', 'DRUM', 'SPOOL', 'BOTTLE', 'JAR', 'CAN', 'BAG', 'BALE', 'OTHER'],
    codeRepresentations: ['DEFAULT', 'KZ_URN', 'SSCC', 'SGTIN', 'RAW'],
  }),
  created() {
    if (this.packageTypeId && this.packageTypeId !== 'new') {
      Masterdata.readPackageType(this.packageTypeId)
        .then((resp) => {
          this.packageType = resp.data
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    }
  },
  methods: {
    save() {
      this.saving = true
      const req = {
        id: this.packageTypeId,
        name: this.packageType.name,
        type: this.packageType.type,
        codeRepresentation: this.packageType.codeRepresentation,
        material: this.packageType.material,
        dryWeight: this.packageType.dryWeight,
        maxGrossWeight: this.packageType.maxGrossWeight,
        description: this.packageType.description,
        innerDimension: {
          width: this.packageType.internalWidth,
          height: this.packageType.internalHeight,
          length: this.packageType.internalLength
        },
        outerDimension: {
          width: this.packageType.externalWidth,
          height: this.packageType.externalHeight,
          length: this.packageType.externalLength
        }
      }

      const call = this.packageTypeId ? Masterdata.updatePackageType(this.packageTypeId, req) : Masterdata.addPackageType(req)
      const action = this.packageTypeId ? 'created' : 'updated'
      return call
        .then(() => {
          miniToastr.success(`Package was ${action}`)
          this.$router.push({ name: 'packageTypes' })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .catch(() => {
          this.saving = false
        })
    }
  },
  computed: {
    isValid() {
      const p = this.packageType
      const moreThanZero = p.internalWidth > -1 && p.internalHeight > -1 && p.internalLength > -1 && p.externalWidth > -1 && p.externalHeight > -1 && p.externalLength > -1 && p.maxGrossWeight > -1 && p.dryWeight > -1
      return (p.name && p.type && p.material) && moreThanZero
    },
    packageTypeId() {
      return parseInt(this.$route.params.id, 10)
    }
  }
}
</script>

<style lang="scss">
.package-type {
  .no-side-padding {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/package/PackageEdit.vue